"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const styles_1 = require("./styles");
const building_blocks_ui_button_1 = require("@acko-tech/building-blocks.ui.button");
const building_blocks_ui_toast_1 = __importDefault(require("@acko-tech/building-blocks.ui.toast"));
const building_blocks_ui_acko_analytics_1 = require("@acko-tech/building-blocks.ui.acko-analytics");
const react_hcaptcha_1 = __importDefault(require("@hcaptcha/react-hcaptcha"));
const utils_1 = require("./utils");
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const loginAPI = __importStar(require("./api"));
const loader_1 = __importDefault(require("./loader"));
const query_string_1 = __importDefault(require("query-string"));
const dummy_1 = require("./dummy");
const back_navigation_1 = __importDefault(require("./components/back-navigation"));
function Login({ configName, callbackVerifyOTPSuccess, r2d2, track, defaultInputValue, loginScreenWrapperHeight, isGenericPage, showNavigation, handleIfLoggedIn, sitekey, disable, iChallansNewFlow, isMobileDevice, }) {
    const [screen, setScreen] = (0, react_1.useState)(utils_1.ComponentToBeRendered.SEND_OTP);
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const [inputValue, setInputValue] = (0, react_1.useState)(defaultInputValue || '');
    const [inputValueError, setInputValueError] = (0, react_1.useState)('');
    const [OTP, setOTP] = (0, react_1.useState)('');
    const [resendOtp, setResendOtp] = (0, react_1.useState)(false);
    const [shouldShowTimer, setShouldShowTimer] = (0, react_1.useState)(false);
    const [verifyOTPApiResponse, setVerifyOTPApiResponse] = (0, react_1.useState)({
        isVerifyOTPError: false,
        errorMessage: '',
    });
    const [sendOTPApiResponse, setSendOTPApiResponse] = (0, react_1.useState)({
        isSendOTPError: false,
        errorMessage: '',
    });
    const [counter, setCounter] = (0, react_1.useState)(utils_1.OTP_WAIT_TIME);
    const [isValidOTP, setIsValidOTP] = (0, react_1.useState)(false);
    const [isVerifyingOTP, setIsVerifyingOTP] = (0, react_1.useState)(false);
    const [verifyOTPCompleted, setVerifyOTPCompleted] = (0, react_1.useState)(false);
    const [toastMsg, setToastMsg] = (0, react_1.useState)('');
    const [toastType, setToastType] = (0, react_1.useState)('error');
    const [config, setConfig] = (0, react_1.useState)({ title: '' });
    const [key, setKey] = (0, react_1.useState)('');
    //Added loading and disabled state to 'Log In' button to prevent multiple clicks and thus preventing multiple sendOtp api calls
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isDisabled, setDisabled] = (0, react_1.useState)(false);
    const [isloggedIn, setIsloggedIn] = (0, react_1.useState)(() => {
        let isUserLoggedIn = false;
        if (typeof window !== 'undefined') {
            (document.cookie || '').split(';').forEach((value) => {
                var _a, _b;
                if (((_a = value === null || value === void 0 ? void 0 : value.trim()) === null || _a === void 0 ? void 0 : _a.indexOf('user_id=')) == 0 &&
                    ((_b = value === null || value === void 0 ? void 0 : value.trim().split('=')[1]) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    isUserLoggedIn = true;
                }
            });
        }
        return isUserLoggedIn;
    });
    // hcaptcha states
    const [token, setToken] = (0, react_1.useState)('');
    const captchaRef = (0, react_1.useRef)(null);
    const timeRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isloggedIn) {
            if (typeof handleIfLoggedIn === 'function') {
                handleIfLoggedIn();
            }
            else {
                handleRedirection();
            }
        }
    }, [isloggedIn]);
    (0, react_1.useEffect)(() => {
        const config = dummy_1.LoginConfig[configName || 'default'];
        setConfig(config);
        setKey((config === null || config === void 0 ? void 0 : config.type) ? 'email' : 'phone');
    }, [configName]);
    const handlePhoneValidation = (number) => {
        let isError = false;
        if (number === '') {
            setInputValueError(utils_1.ErrorMap.EMPTY_ERROR);
            isError = true;
        }
        else if (!utils_1.phoneRegex.test(number)) {
            setInputValueError(utils_1.ErrorMap.INVALID_PHONE);
            isError = true;
        }
        else {
            setInputValueError('');
        }
        return isError;
    };
    const handleEmailValidation = (email) => {
        let isError = false;
        if (email === '') {
            setInputValueError(utils_1.ErrorMap.EMPTY_ERROR);
            isError = true;
        }
        else if (!utils_1.emailRegexp.test(email)) {
            setInputValueError(utils_1.ErrorMap.INVALID_EMAIL);
            isError = true;
        }
        else {
            setInputValueError('');
        }
        return isError;
    };
    const handleOnBlurPhone = () => {
        if (!handlePhoneValidation(inputValue)) {
            r2d2({
                ekind: 'mobile_number_entered',
                edata: {
                    screen: 'universal_login_screen',
                    web_engage: 'true',
                },
                odata: {
                    phone: inputValue,
                },
                okind: 'tracker',
            }).catch(() => null);
        }
        return handlePhoneValidation(inputValue);
    };
    const handleOnBlurEmail = () => {
        return handleEmailValidation(inputValue);
    };
    const handlePhoneNumberChange = (event) => {
        let value = inputValue;
        if (event) {
            value = event.target.value;
        }
        setInputValue(value);
    };
    const handleEmailChange = (event) => {
        let value = inputValue;
        if (event) {
            value = event.target.value;
        }
        setInputValue(value);
    };
    const sendOTPEvents = (input, isResentOTP) => {
        const existingUser = (0, utils_1.getHashParams)();
        const ekind = isResentOTP
            ? 'resend_otp_clicked'
            : existingUser.regNo
                ? 'reg_number_policy_already_exists_non_renewal_send_otp_clicked'
                : 'send_otp_clicked';
        r2d2({
            ekind: ekind,
            edata: {
                screen: (config === null || config === void 0 ? void 0 : config.type)
                    ? 'email_verification_screen'
                    : 'universal_login_screen',
                [key]: input,
                web_engage: 'true',
                product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
            },
            odata: {
                [key]: input,
            },
            okind: 'tracker',
        }).catch(() => null);
        const event = isResentOTP ? 'LoginResendOTPClicked' : 'LoginSendOTPClicked';
        const action = isResentOTP ? 'Resend OTP Clicked' : 'Send OTP Clicked';
        track({
            event: event,
            action: action,
        });
    };
    const handleSubmit = (event) => __awaiter(this, void 0, void 0, function* () {
        event.preventDefault();
        setResendOtp(false);
        setSendOTPApiResponse({
            isSendOTPError: false,
            errorMessage: '',
        });
        setShouldShowTimer(false);
        setCounter(utils_1.OTP_WAIT_TIME);
        setVerifyOTPApiResponse({ isVerifyOTPError: false, errorMessage: '' });
        const isAnyError = (config === null || config === void 0 ? void 0 : config.type)
            ? handleEmailValidation(inputValue)
            : handlePhoneValidation(inputValue);
        if (!isAnyError) {
            // call the execute function of hcaptcha since validation of input is done
            if (captchaRef.current !== null) {
                setLoading(true);
                setDisabled(true);
                console.log('hcaptcha loading');
                timeRef.current = Date.now();
                captchaRef.current.execute();
            }
        }
    });
    // sendOTP is tightly coupled with token from hcaptcha hence moving to useEffect
    (0, react_1.useEffect)(() => {
        if (token.length > 0) {
            const endTime = Date.now();
            const timeTaken = timeRef.current
                ? (endTime - timeRef.current) / 1000
                : '';
            sendOTPEvents(inputValue, false);
            sendOTP();
            (0, building_blocks_ui_acko_analytics_1.trackEvent)('mobile_entered_to_otp_screen', {
                time_taken_by_hcaptcha: timeTaken,
            });
            console.log('Time taken by hcaptcha:', timeTaken);
        }
        else {
            setLoading(false);
            setDisabled(false);
        }
    }, [token]);
    const sendOTP = () => __awaiter(this, void 0, void 0, function* () {
        setInputValueError('');
        loginAPI
            .sendOTP({ phone: inputValue, token: token })
            .then((response) => {
            var _a, _b, _c;
            if (response.data.success) {
                try {
                    (0, building_blocks_ui_acko_analytics_1.trackEvent)('send_otp_success', {
                        url: window.location.href,
                    });
                }
                catch (error) {
                    console.log('error on sending track event - send_otp_success', error);
                }
                r2d2({
                    ekind: 'send_otp_success',
                    edata: {
                        [key]: inputValue,
                        screen: (config === null || config === void 0 ? void 0 : config.type)
                            ? 'email_verification_screen'
                            : 'universal_login_screen',
                        product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
                    },
                    okind: 'tracker',
                }).catch(() => { });
                setScreen(utils_1.ComponentToBeRendered.READ_OTP);
                setShouldShowTimer(true);
                // invoke toaster incase of resend otp
                resendOtp &&
                    invokeToast({ message: 'Resending the OTP', type: 'success' });
                resendOtp && setCounter(utils_1.OTP_WAIT_TIME);
                setSendOTPApiResponse({
                    isSendOTPError: false,
                    errorMessage: '',
                });
            }
            else {
                const errorMsg = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[key][0]) === null || _c === void 0 ? void 0 : _c.human;
                setInputValueError(errorMsg);
                r2d2({
                    ekind: 'send_otp_failure',
                    edata: {
                        [key]: inputValue,
                        screen: (config === null || config === void 0 ? void 0 : config.type)
                            ? 'email_verification_screen'
                            : 'universal_login_screen',
                        product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
                    },
                    okind: 'tracker',
                }).catch(() => { });
                // new relic alerts
            }
        })
            .catch((error) => {
            var _a, _b;
            invokeToast({
                message: 'Something went wrong. Please try again.',
                type: 'error',
            });
            r2d2({
                ekind: 'send_otp_failure',
                edata: {
                    [key]: inputValue,
                    screen: (config === null || config === void 0 ? void 0 : config.type)
                        ? 'email_verification_screen'
                        : 'universal_login_screen',
                    product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
                },
                okind: 'tracker',
            }).catch(() => { });
            // newrelic alerts, if new relic SDK is present
            (_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError(error, {
                name: 'Login module send OTP API failed',
                status: (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status,
                phone: inputValue,
                error,
            });
        })
            .finally(() => {
            setLoading(false);
            setDisabled(false);
        });
    });
    react_1.default.useEffect(() => {
        if (shouldShowTimer) {
            counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
        }
    }, [counter, shouldShowTimer]);
    const invokeToast = ({ message, type }) => {
        setToastMsg(message);
        setToastType(type);
        setTimeout(() => {
            setToastMsg('');
        }, 10000);
    };
    const handleResendOTP = () => {
        setResendOtp(true);
        setOTP('');
        if (captchaRef.current !== null) {
            captchaRef.current.execute();
        }
    };
    const handleRedirection = (redirectURL) => {
        var _a;
        if (redirectURL)
            return (window.location.href = redirectURL);
        const query = window.location.search;
        const params = query_string_1.default.parse(query);
        const nextParam = ((params === null || params === void 0 ? void 0 : params.next) || '');
        const decodedURL = (_a = decodeURIComponent(nextParam)) === null || _a === void 0 ? void 0 : _a.replace(/^.*\/\/[^\/]+/, '').replace(/[&?]/i, '?');
        if (utils_1.javascriptRegex.test(decodedURL) ||
            utils_1.dataRegex.test(decodedURL) ||
            utils_1.domainRegex.test(decodedURL)) {
            return (window.location.href = '/myaccount');
        }
        else
            return (window.location.href = decodedURL || '/myaccount');
    };
    const handleSSOAndRedirection = (sso_urls) => {
        let pendingSSORequests = sso_urls.length;
        if (pendingSSORequests === 0)
            handleRedirection();
        sso_urls.forEach((url) => {
            loginAPI
                .pendingSSORequestsAPICall(url)
                .then(() => null)
                .catch(() => null)
                .finally(() => {
                pendingSSORequests -= 1;
                if (!pendingSSORequests)
                    handleRedirection();
            });
        });
    };
    const webEngageLogin = (phone) => {
        if (
        // @ts-ignore
        typeof window !== undefined &&
            window.webengage &&
            window.webengage.user &&
            typeof window.webengage.user.login === 'function') {
            // @ts-ignore
            window.webengage.user.login(phone);
        }
    };
    const hanldeWebEngageAndSSOURL = (inputValue, ssoURL) => {
        webEngageLogin(inputValue);
        handleSSOAndRedirection(ssoURL);
    };
    react_1.default.useEffect(() => {
        if (isValidOTP) {
            setResendOtp(false);
            setIsVerifyingOTP(true);
            const existingUser = (0, utils_1.getHashParams)();
            const ekind = existingUser.regNo
                ? 'reg_number_policy_already_exists_non_renewal_verify_otp_clicked'
                : 'verify_otp_clicked';
            r2d2({
                ekind: ekind,
                edata: {
                    screen: (config === null || config === void 0 ? void 0 : config.type)
                        ? 'email_verification_screen'
                        : 'universal_login_screen',
                    otp: OTP,
                    [key]: inputValue,
                    web_engage: 'true',
                    product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
                },
                odata: {
                    [key]: inputValue,
                },
                okind: 'tracker',
            }).catch(() => null);
            track({
                event: 'LoginVerifyOTPClicked',
                action: 'Verify OTP Clicked',
            });
            loginAPI
                .verifyOTP({ phone: inputValue, otp: OTP })
                .then((response) => {
                var _a, _b, _c, _d, _e, _f, _g;
                if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.success) {
                    // calling r2d2 as default for all the cases
                    r2d2({
                        ekind: 'otp_verified',
                        edata: {
                            [key]: inputValue,
                            screen: (config === null || config === void 0 ? void 0 : config.type)
                                ? 'email_verification_screen'
                                : 'universal_login_screen',
                            product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
                        },
                        okind: 'tracker',
                    }).catch(() => { });
                    // check for callback function being passes as prop, if not use the default fn.
                    if (callbackVerifyOTPSuccess) {
                        callbackVerifyOTPSuccess();
                    }
                    else {
                        if (config === null || config === void 0 ? void 0 : config.type) {
                            const params = query_string_1.default.parse(window.location.search);
                            const encodedEmail = encodeURIComponent(inputValue);
                            const redirectURL = ((_b = params.redirect) === null || _b === void 0 ? void 0 : _b.indexOf('?')) !== -1
                                ? params.redirect + `&email=${encodedEmail}`
                                : params.redirect + `?email=${encodedEmail}`;
                            handleRedirection(redirectURL);
                        }
                        else {
                            hanldeWebEngageAndSSOURL(inputValue, (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.sso_urls);
                        }
                    }
                    setVerifyOTPCompleted(true);
                }
                else {
                    const errorMsg = (_g = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.errors) === null || _f === void 0 ? void 0 : _f.__all__[0]) === null || _g === void 0 ? void 0 : _g.human;
                    setVerifyOTPApiResponse({
                        isVerifyOTPError: true,
                        errorMessage: errorMsg,
                    });
                    r2d2({
                        ekind: 'incorrect_otp_entered',
                        edata: {
                            [key]: inputValue,
                            message: 'Incorrect otp',
                            screen: (config === null || config === void 0 ? void 0 : config.type)
                                ? 'email_verification_screen'
                                : 'universal_login_screen',
                            product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
                        },
                        okind: 'tracker',
                    }).catch(() => { });
                }
            })
                .catch((error) => {
                var _a, _b;
                invokeToast({
                    message: 'Something went wrong. Please try again.',
                    type: 'error',
                });
                (_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError(error, {
                    name: 'Login module verify OTP API failed',
                    status: (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status,
                    phone: inputValue,
                    error,
                });
            })
                .finally(() => {
                setIsVerifyingOTP(false);
            });
        }
    }, [isValidOTP]);
    react_1.default.useEffect(() => {
        verifyOTPApiResponse.isVerifyOTPError &&
            setVerifyOTPApiResponse({ isVerifyOTPError: false, errorMessage: '' });
    }, [OTP]);
    react_1.default.useEffect(() => {
        r2d2({
            ekind: 'page_head_loaded',
            edata: {},
            odata: {},
            okind: 'tracker',
        }).catch(() => null);
        r2d2({
            ekind: (config === null || config === void 0 ? void 0 : config.type)
                ? 'email_verification_screen_loaded'
                : 'universal_login_screen_loaded',
            edata: {
                screen: (config === null || config === void 0 ? void 0 : config.type)
                    ? 'email_verification_screen'
                    : 'universal_login_screen',
                product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
            },
            okind: 'tracker',
        }).catch(() => null);
    }, []);
    // this useEffect explicitly as we are needing r2d2 event only for otp page load
    react_1.default.useEffect(() => {
        if (screen === utils_1.ComponentToBeRendered.READ_OTP) {
            r2d2({
                ekind: 'otp_screen_loaded',
                edata: {
                    screen: (config === null || config === void 0 ? void 0 : config.type)
                        ? 'email_verification_screen'
                        : 'universal_login_screen',
                    product: (config === null || config === void 0 ? void 0 : config.type) ? 'health_gmc' : undefined,
                },
                okind: 'tracker',
            });
        }
    }, [screen]);
    const ReturnToSendOTPReadInputWrapper = () => (react_1.default.createElement("form", { style: iChallansNewFlow ? { height: '100%' } : null, onSubmit: (event) => handleSubmit(event) },
        react_1.default.createElement(styles_1.Wrapper, { flexDirection: "column", theme: theme, screenHeight: loginScreenWrapperHeight, isGenericPage: isGenericPage, iChallansNewFlow: iChallansNewFlow },
            react_1.default.createElement(building_blocks_ui_common_1.Flex, { flexDirection: "column", alignItems: "baseline" },
                (config === null || config === void 0 ? void 0 : config.phoneEmailInputScreenIcon) && (react_1.default.createElement(styles_1.ImageContainer, { isGenericPage: isGenericPage },
                    react_1.default.createElement("img", { src: config === null || config === void 0 ? void 0 : config.phoneEmailInputScreenIcon, draggable: "false" }))),
                config.title && (react_1.default.createElement(styles_1.Title, { theme: theme, colors: colors, iChallansNewFlow: iChallansNewFlow }, config.title)),
                iChallansNewFlow && config.subTitle ? (react_1.default.createElement(styles_1.SubTitleWrapper, { iChallansNewFlow: iChallansNewFlow, theme: theme },
                    react_1.default.createElement(styles_1.SubTitle, { theme: theme, colors: colors }, config.subTitle))) : null,
                react_1.default.createElement(styles_1.StyledInput, { theme: theme, name: "ReadPhoneEmail", 
                    // we want number keypad for phone and text for email, config?.type is not ideal, but we'll fix it during refactoring
                    type: (config === null || config === void 0 ? void 0 : config.type) ? 'text' : 'number', className: "inputElement", value: inputValue, labelText: (config === null || config === void 0 ? void 0 : config.type)
                        ? 'Your email address'
                        : iChallansNewFlow
                            ? 'Enter your phone no.'
                            : 'Your phone number', disabled: disable || false, hasError: !!inputValueError, onChange: (e) => (config === null || config === void 0 ? void 0 : config.type) ? handleEmailChange(e) : handlePhoneNumberChange(e), onBlur: () => (config === null || config === void 0 ? void 0 : config.type) ? handleOnBlurEmail() : handleOnBlurPhone(), errMsg: inputValueError, leftElement: (config === null || config === void 0 ? void 0 : config.type) ? null : (react_1.default.createElement(styles_1.CountryCodeText, { theme: theme, colors: colors }, "+91")) })),
            react_1.default.createElement(building_blocks_ui_common_1.Flex, { flexDirection: "column", margin: iChallansNewFlow && isMobileDevice ? '144px 0px 0px 0px' : '0px' },
                react_1.default.createElement(building_blocks_ui_button_1.PrimaryButton, { loading: isLoading, disabled: isDisabled, type: "submit" }, config.login_button_text || 'Log in'),
                config.account_recovery ? (react_1.default.createElement(styles_1.AccountRecoveryWrapper, { theme: theme },
                    react_1.default.createElement(styles_1.AccountRecoveryText, null, config.account_recovery_text),
                    react_1.default.createElement(styles_1.AccountRecoveryLink, { theme: theme, colors: colors, href: config.account_recovery_url }, config.account_recovery_link_text))) : null))));
    const ReturnToReadOTPInputWrapper = () => (react_1.default.createElement(styles_1.Wrapper, { flexDirection: "column", theme: theme, screenHeight: loginScreenWrapperHeight, iChallansNewFlow: iChallansNewFlow },
        react_1.default.createElement(react_1.default.Fragment, null,
            showNavigation && (react_1.default.createElement(styles_1.NavigationBarContainer, null,
                react_1.default.createElement(back_navigation_1.default, null))),
            (config === null || config === void 0 ? void 0 : config.otpInputScreenIcon) && (react_1.default.createElement(styles_1.ImageContainer, { isGenericPage: isGenericPage },
                react_1.default.createElement("img", { src: config === null || config === void 0 ? void 0 : config.otpInputScreenIcon, draggable: "false" }))),
            react_1.default.createElement(styles_1.Title, { theme: theme, colors: colors }, utils_1.SEND_OTP_COMPONET_DATA.title),
            react_1.default.createElement(styles_1.SubTitleWrapper, { theme: theme },
                react_1.default.createElement(styles_1.SubTitle, { theme: theme, colors: colors }, `${utils_1.SEND_OTP_COMPONET_DATA.subTitle} ${inputValue}`),
                react_1.default.createElement(styles_1.RerouteText, { theme: theme, colors: colors, onClick: () => {
                        setScreen(utils_1.ComponentToBeRendered.SEND_OTP);
                        setShouldShowTimer(false);
                        setCounter(utils_1.OTP_WAIT_TIME);
                    } }, utils_1.SEND_OTP_COMPONET_DATA.edit)),
            react_1.default.createElement(building_blocks_ui_common_1.Flex, { alignItems: "center" },
                react_1.default.createElement(styles_1.StyledOTPInput, { theme: theme, setIsValidOTP: (value) => setIsValidOTP(value), setOTP: setOTP, OTP: OTP, verifyOTPApiResponse: verifyOTPApiResponse, sendOTPApiResponse: sendOTPApiResponse, enableAutoReadOTP: true, isEmailLogin: false }),
                isVerifyingOTP && react_1.default.createElement(loader_1.default, null),
                verifyOTPCompleted && (react_1.default.createElement(styles_1.CheckGreenIcon, { src: "https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/check-green.svg" }))),
            react_1.default.createElement(building_blocks_ui_common_1.Flex, { alignItems: "center", mt: theme === null || theme === void 0 ? void 0 : theme.spacing[2] }, verifyOTPApiResponse.isVerifyOTPError && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.ErrorText, { theme: theme, colors: colors }, verifyOTPApiResponse.errorMessage)))),
            react_1.default.createElement(building_blocks_ui_common_1.Flex, { mt: theme === null || theme === void 0 ? void 0 : theme.spacing[4] }, (config === null || config === void 0 ? void 0 : config.type) ? (react_1.default.createElement(styles_1.ReSendOTPContainer, null,
                react_1.default.createElement(styles_1.ResendTitle, null, "Didn\u2019t receive an access code?"),
                react_1.default.createElement(styles_1.ResendSubTitle, null, "Depending on your company policy, access code may take up to 30 minutes to reach your inbox."),
                counter <= 0 && shouldShowTimer ? (react_1.default.createElement(styles_1.RerouteText, { onClick: handleResendOTP, theme: theme, colors: colors, marginLeft: "0", disabled: sendOTPApiResponse.isSendOTPError }, "Resend OTP")) : (react_1.default.createElement(styles_1.SubTitle, { theme: theme, colors: colors },
                    "Resend OTP in 00:",
                    counter.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false,
                    }))))) : (react_1.default.createElement(react_1.default.Fragment, null, counter <= 0 && shouldShowTimer ? (react_1.default.createElement(styles_1.RerouteText, { onClick: handleResendOTP, theme: theme, colors: colors, marginLeft: "0" }, "Resend OTP")) : (react_1.default.createElement(styles_1.SubTitle, { theme: theme, colors: colors },
                "Resend OTP in 00:",
                counter.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                })))))),
            iChallansNewFlow ? (react_1.default.createElement(building_blocks_ui_common_1.Flex, { flexDirection: "column", mt: "auto" },
                react_1.default.createElement(building_blocks_ui_button_1.PrimaryButton, { loading: isLoading, disabled: isDisabled, type: "submit" }, 'Check challans'))) : null)));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        screen === utils_1.ComponentToBeRendered.SEND_OTP &&
            ReturnToSendOTPReadInputWrapper(),
        screen === utils_1.ComponentToBeRendered.READ_OTP
            ? ReturnToReadOTPInputWrapper()
            : null,
        toastMsg.length > 0 ? (react_1.default.createElement(building_blocks_ui_toast_1.default, { toastMessage: toastMsg, toastType: toastType })) : null,
        react_1.default.createElement("form", null,
            react_1.default.createElement(react_hcaptcha_1.default, { sitekey: sitekey, size: "invisible", onVerify: (token) => token && setToken(token), onError: (err) => {
                    setToken('');
                    setSendOTPApiResponse({
                        isSendOTPError: true,
                        errorMessage: err,
                    });
                    console.error('Hcaptcha token generation failed ', err);
                    window === null || window === void 0 ? void 0 : window.newrelic.noticeError(err, {
                        name: 'Hcaptcha token generation failed ',
                        token: token,
                    });
                    setLoading(false);
                    setDisabled(false);
                }, ref: captchaRef }))));
}
exports.default = Login;
//# sourceMappingURL=login.js.map